module.exports = __webpack_public_path__ + "img/moon-cloud-rain.e2bf7a5.svg";